<template>
  <div class="switch-list">
    <div class="list-card md-elevation-3 white bg">
      <div class="subpanel-header">
        <div class="md-title title-line">
          {{ title }}
          <md-button v-if="canClose" class="md-icon-button md-dense close-button" @click="close">
            <md-icon class="icon">close</md-icon>
          </md-button>
        </div>
        <div class="md-caption caption-line">
          <div>
            <span>{{ subtitle }}</span>
          </div>
          <div v-if="loading">
            <md-progress-bar v-if="loading" md-mode="indeterminate" />
          </div>
        </div>      
      </div>
      <md-content class="scroll-content md-scrollbar">
        <div class="column column-left">
          <div v-if="leftHeading" class="md-caption column-header">{{ leftHeading }}</div>
          <slot name="left-slot" />
          <md-switch
            v-for="(item) of items" 
            :key="item.key"
            :value="item.on"
            :disabled="readonly || item.disabled"
            class="md-primary"
            :class="{ 
              disabled: readonly || item.disabled,
              selected: item.on,
              error: item.error 
            }"
            @mouseover.native="mouseOver(item)"
            @mouseleave.native="mouseLeave(item)"
            @change="value => toggleSwitch(item, value)"
          />
        </div>
        <div class="column column-right">
          <div v-if="rightHeading" class="md-caption column-header name-header">{{ rightHeading }}</div>
          <slot name="right-slot" />
          <switch-item
            v-for="(item) of items" 
            :key="item.key"
            :label="item.label"
            :show-caret="item.showCaret"
            :selected="selected === item.key"
            :disabled="item.disabled"
            :error="item.error"
            :warning="item.warning"
            :tooltip="item.tooltip"
            icon=""
            @click="selectItem(item)"
            @mouseOver="mouseOver(item)"
            @mouseLeave="mouseLeave(item)"
          />
        </div>
      </md-content>
    </div>
  </div>
</template>

<script>
import SwitchItem from './SwitchItem';

export default {
  name: 'switch-list',
  components: {
    SwitchItem,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
    leftHeading: {
      type: String,
      default: null,
    },
    rightHeading: {
      type: String,
      default: null,
    },
    selected: {
      type: String,
      default: null,
    },
    canClose: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      state: {
      },
    };
  },
  methods: {
    toggleSwitch(item, value) {
      this.$emit('toggle', item, value);
    },
    selectItem(item) {
      this.$emit('select', item);
    },
    mouseOver(item) {
      this.$emit('mouseOver', item);
    },
    mouseLeave(item) {
      this.$emit('mouseLeave', item);
    },
    close() {
      this.$emit('close');
    },
  }
}
</script>

<style scoped>
.switch-list {
  min-width: 250px;
}

.list-card {
  height: 100%;
  padding: 10px 10px 0px 10px;
  border-radius: 5px;
}

.subpanel-header {
  border-bottom: 1px solid darkgray;
  padding-bottom: 10px;
}

.md-content {
  height: calc(100% - 64px);
  overflow-y: auto;
  overflow-x: hidden;
}

.scroll-content {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

.title-line {
  display: flex;
  justify-content: space-between;
}

.close-button {
  margin-top: -4px;
  margin-right: -6px;
}

.caption-line {
  height: 24px;
}

.column {
  display: flex;
  flex-direction: column;
}

.column-left {
  border-right: 1px solid darkgray;
  min-width: 60px;
}

.column-right {
  flex-grow: 1;
}

.column-header {
  padding-top: 8px;
}

.name-header {
  padding-left: 10px;
}

.md-switch {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 3rem;
  padding-left: 10px;
  padding-right: 16px;
  margin: 0;
}

.md-switch.md-theme-default.md-disabled >>> .md-switch-thumb,
.md-switch.md-theme-default.md-checked.md-primary.disabled >>> .md-switch-thumb,
.md-switch.md-theme-default.md-checked.md-primary.error >>> .md-switch-thumb {
  background-color: var(--md-theme-default-switchvariant, #f5f5f5);
}

.md-switch.selected >>> .md-switch-container {
  background-color: lightblue;
}

.md-switch.md-theme-default.md-checked.md-primary.error >>> .md-switch-container {
  background-color: #f92c2d;
}
</style>